import { getTypoConfig } from '../../components/typography/TypographyUtils';
import { BLACK_100, BLACK_700, BLACK_900, BLUE_500 } from '../colors';
import { PRIMARY_BOLD_FONT, PRIMARY_FONT } from '../fonts';
var headingConfig = {
  h6: getTypoConfig({
    fontSize: 24,
    lineHeight: 28,
    letterSpacing: -0.3,
    color: BLACK_900
  }),
  h5: getTypoConfig({
    fontSize: 28,
    lineHeight: 36,
    letterSpacing: -0.3,
    color: BLACK_900
  }),
  h4: getTypoConfig({
    fontSize: 32,
    lineHeight: 40,
    letterSpacing: -0.4,
    color: BLACK_900
  }),
  h3: getTypoConfig({
    fontSize: 36,
    lineHeight: 44,
    letterSpacing: -0.4,
    color: BLACK_900
  }),
  h2: getTypoConfig({
    fontSize: 44,
    lineHeight: 56,
    letterSpacing: -0.4,
    color: BLACK_900
  }),
  h1: getTypoConfig({
    fontSize: 48,
    lineHeight: 60,
    letterSpacing: -0.4,
    color: BLACK_900
  }),
  'h6-bold': getTypoConfig({
    fontSize: 24,
    lineHeight: 28,
    letterSpacing: -0.3,
    color: BLACK_900,
    isBold: true
  }),
  'h5-bold': getTypoConfig({
    fontSize: 28,
    lineHeight: 36,
    letterSpacing: -0.3,
    color: BLACK_900,
    isBold: true
  }),
  'h4-bold': getTypoConfig({
    fontSize: 32,
    lineHeight: 40,
    letterSpacing: -0.4,
    color: BLACK_900,
    isBold: true
  }),
  'h3-bold': getTypoConfig({
    fontSize: 36,
    lineHeight: 44,
    letterSpacing: -0.4,
    color: BLACK_900,
    isBold: true
  }),
  'h2-bold': getTypoConfig({
    fontSize: 44,
    lineHeight: 56,
    letterSpacing: -0.4,
    color: BLACK_900,
    isBold: true
  }),
  'h1-bold': getTypoConfig({
    fontSize: 48,
    lineHeight: 60,
    letterSpacing: -0.4,
    color: BLACK_900,
    isBold: true
  })
};
var bodyParaConfig = {
  'body-para-xxxs': getTypoConfig({
    fontSize: 8,
    lineHeight: 10,
    letterSpacing: 0.12,
    color: BLACK_900
  }),
  'body-para-xxs': getTypoConfig({
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0.16,
    color: BLACK_900
  }),
  'body-para-xs': getTypoConfig({
    fontSize: 12,
    lineHeight: 18,
    letterSpacing: 0,
    color: BLACK_900
  }),
  'body-para-sm': getTypoConfig({
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.07,
    color: BLACK_900
  }),
  'body-para-md': getTypoConfig({
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: -0.16,
    color: BLACK_900
  }),
  'body-para-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 26,
    letterSpacing: -0.2,
    color: BLACK_900
  }),
  'body-para-xl': getTypoConfig({
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: -0.24,
    color: BLACK_900
  }),
  'body-para-xxxs-bold': getTypoConfig({
    fontSize: 8,
    lineHeight: 10,
    letterSpacing: 0.12,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-xxs-bold': getTypoConfig({
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0.16,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-xs-bold': getTypoConfig({
    fontSize: 12,
    lineHeight: 18,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-sm-bold': getTypoConfig({
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: -0.07,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-md-bold': getTypoConfig({
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: -0.16,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-lg-bold': getTypoConfig({
    fontSize: 18,
    lineHeight: 26,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true
  }),
  'body-para-xl-bold': getTypoConfig({
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: -0.24,
    color: BLACK_900,
    isBold: true
  })
};
var bodySingleLineConfig = {
  'body-single-line-xxxs': getTypoConfig({
    fontSize: 8,
    lineHeight: 10,
    letterSpacing: 0.2,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-xxs': getTypoConfig({
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.16,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-xs': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-sm': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-md': getTypoConfig({
    fontSize: 16,
    lineHeight: 18,
    letterSpacing: -0.16,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-xl': getTypoConfig({
    fontSize: 20,
    lineHeight: 22,
    letterSpacing: -0.24,
    color: BLACK_900,
    isSingleLine: true
  }),
  'body-single-line-xxxs-bold': getTypoConfig({
    fontSize: 8,
    lineHeight: 10,
    letterSpacing: 0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-xxs-bold': getTypoConfig({
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.16,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-xs-bold': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-sm-bold': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-md-bold': getTypoConfig({
    fontSize: 16,
    lineHeight: 18,
    letterSpacing: -0.16,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-lg-bold': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'body-single-line-xl-bold': getTypoConfig({
    fontSize: 20,
    lineHeight: 22,
    letterSpacing: -0.24,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  })
};
var bodyHyperlinkConfig = {
  'body-hyperlink-xxs': getTypoConfig({
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.16,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  }),
  'body-hyperlink-xs': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  }),
  'body-hyperlink-sm': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  }),
  'body-hyperlink-md': getTypoConfig({
    fontSize: 16,
    lineHeight: 18,
    letterSpacing: -0.16,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  }),
  'body-hyperlink-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  }),
  'body-hyperlink-xl': getTypoConfig({
    fontSize: 20,
    lineHeight: 22,
    letterSpacing: -0.24,
    color: BLUE_500,
    isBold: true,
    isSingleLine: false
  })
};
var titleParaConfig = {
  'title-para-sm': getTypoConfig({
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0.64,
    color: BLACK_700,
    isBold: true,
    isUppercase: true
  }),
  'title-para-md': getTypoConfig({
    fontSize: 12,
    lineHeight: 18,
    letterSpacing: 0.32,
    color: BLACK_700,
    isBold: true,
    isUppercase: true
  }),
  'title-para-lg': getTypoConfig({
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: 0.16,
    color: BLACK_700,
    isBold: true,
    isUppercase: true
  })
};
var titleSingleLineConfig = {
  'title-single-line-sm': getTypoConfig({
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.64,
    color: BLACK_700,
    isBold: true,
    isSingleLine: true,
    isUppercase: true
  }),
  'title-single-line-md': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.32,
    color: BLACK_700,
    isBold: true,
    isSingleLine: true,
    isUppercase: true
  }),
  'title-single-line-lg': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0.16,
    color: BLACK_700,
    isBold: true,
    isSingleLine: true,
    isUppercase: true
  }),
  'title-single-line-xl': getTypoConfig({
    fontSize: 16,
    lineHeight: 18,
    letterSpacing: 0.8,
    color: BLACK_700,
    isBold: true,
    isSingleLine: true,
    isUppercase: true
  })
};
var buttonTextConfig = {
  'button-text-primary-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_100,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-primary-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_100,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-primary-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_100,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-secondary-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-secondary-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-secondary-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-tertiary-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLUE_500,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-tertiary-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLUE_500,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-tertiary-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLUE_500,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-light-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-light-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-light-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-dark-sm': getTypoConfig({
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-dark-md': getTypoConfig({
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: -0.08,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  }),
  'button-text-alternate-dark-lg': getTypoConfig({
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: -0.2,
    color: BLACK_900,
    isBold: true,
    isSingleLine: true
  })
};
var typographyLightConfig = {
  theme: 'light',
  text: null,
  type: 'h6',
  isBold: false,
  color: null,
  multiText: [],
  config: {
    fontFamilyRegular: PRIMARY_FONT,
    fontFamilyBold: PRIMARY_BOLD_FONT,
    regularFontWeight: '400',
    boldFontWeight: '700',
    types: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, headingConfig), bodyParaConfig), bodySingleLineConfig), bodyHyperlinkConfig), titleParaConfig), titleSingleLineConfig), buttonTextConfig)
  }
};
var typographyDarkConfig = {
  theme: 'light',
  text: null,
  type: 'h6',
  isBold: false,
  color: null,
  multiText: [],
  config: {
    fontFamilyRegular: PRIMARY_FONT,
    fontFamilyBold: PRIMARY_BOLD_FONT,
    regularFontWeight: '400',
    boldFontWeight: '700',
    types: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      headingConfig,
      h6: Object.assign(Object.assign({}, headingConfig['h6']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h6'].typographyStyles), {
          color: BLACK_100
        })
      }),
      h5: Object.assign(Object.assign({}, headingConfig['h5']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h5'].typographyStyles), {
          color: BLACK_100
        })
      }),
      h4: Object.assign(Object.assign({}, headingConfig['h4']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h4'].typographyStyles), {
          color: BLACK_100
        })
      }),
      h3: Object.assign(Object.assign({}, headingConfig['h3']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h3'].typographyStyles), {
          color: BLACK_100
        })
      }),
      h2: Object.assign(Object.assign({}, headingConfig['h2']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h2'].typographyStyles), {
          color: BLACK_100
        })
      }),
      h1: Object.assign(Object.assign({}, headingConfig['h1']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h1'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h6-bold': Object.assign(Object.assign({}, headingConfig['h6-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h6-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h5-bold': Object.assign(Object.assign({}, headingConfig['h5-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h5-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h4-bold': Object.assign(Object.assign({}, headingConfig['h4-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h4-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h3-bold': Object.assign(Object.assign({}, headingConfig['h3-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h3-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h2-bold': Object.assign(Object.assign({}, headingConfig['h2-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h2-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'h1-bold': Object.assign(Object.assign({}, headingConfig['h1-bold']), {
        typographyStyles: Object.assign(Object.assign({}, headingConfig['h1-bold'].typographyStyles), {
          color: BLACK_100
        })
      })
    }, Object.assign(Object.assign({}, bodyParaConfig), {
      'body-para-xxxs': Object.assign(Object.assign({}, bodyParaConfig['body-para-xxxs']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xxxs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xxs': Object.assign(Object.assign({}, bodyParaConfig['body-para-xxs']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xxs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xs': Object.assign(Object.assign({}, bodyParaConfig['body-para-xs']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-sm': Object.assign(Object.assign({}, bodyParaConfig['body-para-sm']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-sm'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-md': Object.assign(Object.assign({}, bodyParaConfig['body-para-md']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-md'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-lg': Object.assign(Object.assign({}, bodyParaConfig['body-para-lg']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-lg'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xl': Object.assign(Object.assign({}, bodyParaConfig['body-para-xl']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xl'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xxxs-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-xxxs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xxxs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xxs-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-xxs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xxs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xs-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-xs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-sm-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-sm-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-sm-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-md-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-md-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-md-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-lg-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-lg-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-lg-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-para-xl-bold': Object.assign(Object.assign({}, bodyParaConfig['body-para-xl-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodyParaConfig['body-para-xl-bold'].typographyStyles), {
          color: BLACK_100
        })
      })
    })), Object.assign(Object.assign({}, bodySingleLineConfig), {
      'body-single-line-xxxs': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxxs']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxxs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xxs': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxs']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xs': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xs']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xs'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-sm': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-sm']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-sm'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-md': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-md']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-md'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-lg': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-lg']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-lg'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xl': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xl']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xl'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xxxs-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxxs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxxs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xxs-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xxs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xs-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xs-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xs-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-sm-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-sm-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-sm-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-md-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-md-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-md-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-lg-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-lg-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-lg-bold'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'body-single-line-xl-bold': Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xl-bold']), {
        typographyStyles: Object.assign(Object.assign({}, bodySingleLineConfig['body-single-line-xl-bold'].typographyStyles), {
          color: BLACK_100
        })
      })
    })), bodyHyperlinkConfig), Object.assign(Object.assign({}, titleParaConfig), {
      'title-para-sm': {
        typographyStyles: Object.assign(Object.assign({}, titleParaConfig['title-para-sm'].typographyStyles), {
          color: BLACK_100
        })
      },
      'title-para-md': {
        typographyStyles: Object.assign(Object.assign({}, titleParaConfig['title-para-md'].typographyStyles), {
          color: BLACK_100
        })
      },
      'title-para-lg': {
        typographyStyles: Object.assign(Object.assign({}, titleParaConfig['title-para-lg'].typographyStyles), {
          color: BLACK_100
        })
      }
    })), Object.assign(Object.assign({}, titleSingleLineConfig), {
      'title-single-line-sm': Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-sm']), {
        typographyStyles: Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-sm'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'title-single-line-md': Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-md']), {
        typographyStyles: Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-md'].typographyStyles), {
          color: BLACK_100
        })
      }),
      'title-single-line-lg': Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-lg']), {
        typographyStyles: Object.assign(Object.assign({}, titleSingleLineConfig['title-single-line-lg'].typographyStyles), {
          color: BLACK_100
        })
      })
    }))
  }
};
export default {
  light: typographyLightConfig,
  dark: typographyDarkConfig,
  white: typographyLightConfig
};